import { useEffect, useState } from "react";
import { http } from "@/lib/api";
export default function useConfig() {
  const [cfg, setCfg] = useState({ whatsapp: "+91-00000-00000", email: "hello@medipats.com" });
  useEffect(() => { http.get("/config").then(r => setCfg(r.data)).catch(()=>{}); }, []);
  const waNumber = (cfg.whatsapp || "").replace(/\D/g, "");
  const waLink = (msg) => `https://wa.me/${waNumber || "0000000000"}?text=${encodeURIComponent(msg || "Hello MediPats, I'd like help planning medical treatment in India.")}`;
  return { ...cfg, waLink };
}
